/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { EngineersJobEngineer } from '../models/engineers-job-engineer';
import { Envelope } from '../models/envelope';
import {JobsJobWork} from '@app/modules/operations-api/models/jobs-job-work';
import {Engineer} from '@models/engineer';
@Injectable({
  providedIn: 'root',
})
class JobEngineerService extends __BaseService {
  static readonly JobEngineerGetAllPath = '/api/jobengineer';
  static readonly JobEngineerUpdatePath = '/api/jobengineer';
  static readonly JobEngineerCreatePath = '/api/jobengineer';
  static readonly JobEngineerGetPath = '/api/jobengineer/{id}';
  static readonly JobEngineerDeletePath = '/api/jobengineer/{id}';
  static readonly JobEngineerAddEngineerToJobPath = '/api/jobengineer/{engineerId}/{jobId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return OK
   */
  JobEngineerGetAllResponse(): __Observable<__StrictHttpResponse<Envelope<EngineersJobEngineer[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/jobengineer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<EngineersJobEngineer[]>>;
      })
    );
  }
  /**
   * @return OK
   */
  JobEngineerGetAll(): __Observable<Envelope<EngineersJobEngineer[]>> {
    return this.JobEngineerGetAllResponse().pipe(
      __map(_r => _r.body as Envelope<EngineersJobEngineer[]>)
    );
  }

  /**
   * @param jobEngineer undefined
   * @return OK
   */
  JobEngineerUpdateResponse(jobEngineer: EngineersJobEngineer): __Observable<__StrictHttpResponse<Envelope<EngineersJobEngineer>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = jobEngineer;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/jobengineer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<EngineersJobEngineer>>;
      })
    );
  }
  /**
   * @param jobEngineer undefined
   * @return OK
   */
  JobEngineerUpdate(jobEngineer: EngineersJobEngineer): __Observable<Envelope<EngineersJobEngineer>> {
    return this.JobEngineerUpdateResponse(jobEngineer).pipe(
      __map(_r => _r.body as Envelope<EngineersJobEngineer>)
    );
  }

  /**
   * @param jobEngineer undefined
   * @return OK
   */
  JobEngineerCreateResponse(jobEngineer: EngineersJobEngineer): __Observable<__StrictHttpResponse<Envelope<EngineersJobEngineer>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = jobEngineer;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/jobengineer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<EngineersJobEngineer>>;
      })
    );
  }
  /**
   * @param jobEngineer undefined
   * @return OK
   */
  JobEngineerCreate(jobEngineer: EngineersJobEngineer): __Observable<Envelope<EngineersJobEngineer>> {
    return this.JobEngineerCreateResponse(jobEngineer).pipe(
      __map(_r => _r.body as Envelope<EngineersJobEngineer>)
    );
  }

  /**
   * @param id undefined
   * @return OK
   */
  JobEngineerGetResponse(id: number): __Observable<__StrictHttpResponse<Envelope<EngineersJobEngineer>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/jobengineer/${encodeURIComponent(id)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<EngineersJobEngineer>>;
      })
    );
  }
  /**
   * @param id undefined
   * @return OK
   */
  JobEngineerGet(id: number): __Observable<Envelope<EngineersJobEngineer>> {
    return this.JobEngineerGetResponse(id).pipe(
      __map(_r => _r.body as Envelope<EngineersJobEngineer>)
    );
  }

  /**
   * @param id undefined
   * @return OK
   */
  JobEngineerDeleteResponse(id: number): __Observable<__StrictHttpResponse<Envelope<any>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/jobengineer/${encodeURIComponent(id)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<any>>;
      })
    );
  }
  /**
   * @param id undefined
   * @return OK
   */
  JobEngineerDelete(id: number): __Observable<Envelope<any>> {
    return this.JobEngineerDeleteResponse(id).pipe(
      __map(_r => _r.body as Envelope<any>)
    );
  }

  /**
   * @param params The `JobEngineerService.JobEngineerAddEngineerToJobParams` containing the following parameters:
   *
   * - `jobId`:
   *
   * - `engineerId`:
   *
   * @return OK
   */
  JobEngineerAddEngineerToJobResponse(params: JobEngineerService.JobEngineerAddEngineerToJobParams): __Observable<__StrictHttpResponse<Envelope<EngineersJobEngineer>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/jobengineer/${encodeURIComponent(params.engineerId)}/${encodeURIComponent(params.jobId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<EngineersJobEngineer>>;
      })
    );
  }
  /**
   * @param params The `JobEngineerService.JobEngineerAddEngineerToJobParams` containing the following parameters:
   *
   * - `jobId`:
   *
   * - `engineerId`:
   *
   * @return OK
   */
  JobEngineerAddEngineerToJob(params: JobEngineerService.JobEngineerAddEngineerToJobParams): __Observable<Envelope<EngineersJobEngineer>> {
    return this.JobEngineerAddEngineerToJobResponse(params).pipe(
      __map(_r => _r.body as Envelope<EngineersJobEngineer>)
    );
  }
}

module JobEngineerService {

  /**
   * Parameters for JobEngineerAddEngineerToJob
   */
  export interface JobEngineerAddEngineerToJobParams {
    jobId: number;
    engineerId: number;
  }
}

export { JobEngineerService }
